import styles from "../TermsConditions/TermsConditions.module.css";

export default function Gdpr() {
  return (
    <div className={`${styles.terms_conditions} container`}>
      <h1 className={styles.h1}>GDPR – Personal Data Policy</h1>
      <hr />
      <div className={styles.text_container}>
        <div>
          <h3>Terms and Definitions</h3>
          <p>Hereinafter “International Chemical Secretariat”, shall be referred to as “ChemSec” or the ‘Company’.</p>
          <p>Persons who come into contact with ChemSec whose personal data is affected are hereinafter referred to as ‘The Registered Party’ or ‘You’.</p>
          <p>By ”personal data” it is meant that every piece of information that refers to an identified or identifiable physical person who is alive. That is, information that can be linked directly or indirectly to a person; for example, name, address, telephone number, personal number or IP address.</p>
        </div>
        <div>
          <h3>Basic information</h3>
          <p>
            ChemSec undertakes to manage personal data in accordance with
            Swedish legislation. ChemSec defends your personal integrity and
            endeavours to protect your right in the best possible manner. This
            policy describes how ChemSec collects and manages personal data.
          </p>
        </div>
        <div>
          <h3>Which personal data are collected?</h3>
          <p>
            ChemSec collects and stores personal data that is needed, essential,
            and compatible with The Company’s purpose. Personal data may be
            collected and stored in connection with ChemSec’s business. In the
            process of registration with ChemSec’s newsletter, name, email
            address, and telephone number are collected. When ChemSec collects
            personal data from public sources, name, email address, telephone
            number and information on title or position and profession are
            collected.
          </p>
        </div>
        <div>
          <h3>Purpose and the Legal Ground for Processing</h3>
          <p>ChemSec collects and stores registered personal information for the purpose of managing the Company’s business and to ensure that this is accomplished in a manner relating to its purpose.</p>
          <p>Personal data is collected and stored for the purpose of registering You as a subscriber to a newsletter. The Company processes your personal data to this end with your consent.</p>
          <p>In other communication, your personal information is collected by the Company for the purpose of answering questions and for continuing communication Storing and processing then takes place with your consent.</p>
          <p>ChemSec has a legal interest in collecting personal information from public sources in order to contact persons who are professionally active within the area of the Company’s business activities. Personal information is used with the objective of communicating with the Registered Party via e-mail or telephone in pursuit of the Company’s mission. The consent of the Registered Party is to be obtained for the storage of any of this information.</p>
        </div>
        <div>
          <h3>How long is the personal information kept?</h3>
          <p>
            ChemSec keeps the Registered Party’s information as long as it is
            needed for the purpose in pursuit of which it was collected and
            processed, or as long as is needed in accordance with any laws or
            constitutions. This means, for example, that ChemSec stores personal
            information that has been collected as part of registration for the
            Company’s newsletter for as long as you wish to subscribe to the
            newsletter.
          </p>
        </div>
        <div>
          <h3>Who has access to the personal information?</h3>
          <p>
            ChemSec reserves the right to release personal information to
            supervisory authorities in order to meet Chemsec’s legal
            obligations. ChemSec might also share personal data with third
            parties that provide services to organisations, e.g., IT services.
            In such cases, ChemSec might share Your personal information with
            parties outside the EU if the country has an adequate level of
            protection according to the Commission, or after you have given your
            explicit consent to this. If Your consent is required, You have a
            right to information relevant to the risks of processing.
          </p>
        </div>
        <div>
          <h3>Security</h3>
          <p>
            ChemSec shall take appropriate measures–including organisational–to
            minimise the risks of unauthorised access and inappropriate use
            Measures will be taken and applied in accordance with ChemSec’s
            internal routines to secure the integrity of the Registered Party.
          </p>
        </div>
        <div>
          <h3>The rights of a Registered Party</h3>
          <p>The Registered Party is personally responsible for keeping his or her personal information updated and correct. So that ChemSec can continue to fulfil its commitments. ChemSec accepts no liability for consequences ensuing from incorrect personal data.</p>
          <p>The Registered Party has the right to request information at any time about the personal data that ChemSec has stored on the Registered Party.</p>
          <p>The Registered Party always has the right to question the processing of the Registered Party’s data insofar as the legal basis for processing rests on a weighing of interest.</p>
          <p>The Registered Party has the right to have his or her personal data deleted as provided by Swedish law. This right does not apply if there another legal basis exists for processing or if ChemSec is otherwise legally obliged to process personal data.</p>
          <p>The Registered Party has the right to request that ChemSec’’s processing of the Registered Party’s personal data be restricted. However, this could affect the Registered Party’s opportunity to participate in ChemSec’s business activities.</p>
          <p>The Registered Party has the right to rectify wrong, incomplete or misleading information.</p>
          <p>The Registered Party has the right to obtain personal information that affects him or her in a structured commonly used and digital format and to have the information transferred from ChemSec to another entity similarly responsible for personal data.</p>
          <p>The Registered Party has the right to revoke consent previously given. If a revocation is implemented, processing of the Registered Party’s personal data must cease immediately.</p>
          <p>The Registered Party shall have the means and right to complain to a national authority (Data Inspectorate) if the Registered Party feels that ChemSec is managing the personal information wrongfully.</p>
        </div>
        <div>
          <h3>
            Contact information for the entity responsible for personal data
          </h3>
          <ul className={styles.contact}>
            <li>Contact person: ChemSec data protection officer</li>
            <li>Email: <a href="mailto:GDPR@chemsec.org">GDPR@chemsec.org</a></li>
            <li>Telephone number: <a href="tel:+46 31 711 04 95">+46 31 711 04 95</a></li>
            <li>Address: Första Långgatan 18, 413 28 Göteborg</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
